var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.seed)?_c('lab-task',[_c('lab-sim',{attrs:{"lab-name":"freezing-point-depression","seed":_vm.seed,"allGuidanceComplete":"submitResponse"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }